import React from 'react';
import {callAction} from 'client/framework';
import Checkbox from 'generic/Forms/Checkbox/Checkbox.react';
import usageReportsStore from '../UsageReports.store';
import usageReportsActions from '../UsageReports.actions';

export default class ClassroomStatusFilters extends React.Component {
  onClassStatusClick = (e) => {
    callAction(usageReportsActions.TOGGLE_CLASSROOM_STATUS, e.target.name);
  };

  render() {
    return (
      <div>
        <Checkbox
          label='Show active classes'
          name='active'
          disabled={usageReportsStore.isClassroomStatusDisabled('active')}
          checked={usageReportsStore.isClassroomStatusToggled('active')}
          onChange={this.onClassStatusClick}
        />
        <Checkbox
          label='Show archived classes'
          name='archived'
          disabled={usageReportsStore.isClassroomStatusDisabled('archived')}
          checked={usageReportsStore.isClassroomStatusToggled('archived')}
          onChange={this.onClassStatusClick}
        />
      </div>
    );
  }
}
